<style lang="less">
  @import "../../vars.less";
  .advertisement-title {
    font-size: 14px;
    padding: 0 @space-normal;
    color: @text-color;
  }
  .advertisement-content {
    font-size: 12px;
    padding: @space-normal;
    padding-top: 0;
    color: @text-color;

    img {
      width: 100%;
    }

    video {
      width: 100%;
    }

    iframe {
      width: 100%;
    }
  }

</style>

<template>
  <page-container
    class="advertisement"
    :title="title">
    <h3 class="advertisement-title">{{ title }}</h3>
    <div class="advertisement-content" v-html="content" />
  </page-container>
</template>

<script>
import localforage from 'localforage'
import PageContainer from '../../components/PageContainer'
import { LF_KEYS } from '../../constants'

export default {
  name: 'advertisement',
  components: { PageContainer },
  data () {
    return {
      title: '',
      content: ''
    }
  },
  beforeCreate () {
    if (!this.$route.query.id) {
      this.$$back()
    }
  },
  mounted () {
    localforage.getItem(LF_KEYS.ADVERTISEMENTS).then(res => {
      if (res && res.length) {
        const adv = res.find(item => item.id === this.$route.query.id)
        if (adv) {
          this.title = adv.title
          this.content = adv.content
        }
      }
    })
  }
}
</script>
